import { ApolloError, gql, useQuery } from '@apollo/client';
import {
  Payments_GetManualDepositsQuery,
  Payments_GetManualDepositsQueryVariables,
} from '@/types';

const MANUAL_DEPOSIT_SUMMARY_FRAGMENT = gql`
  fragment ManualDepositSummaryFields on ManualDepositSummary {
    cash_count
    check_count
    deposit_date
    deposit_number
    manual_deposit_id
    total_amount_in_micros
  }
`;

export const GET_MANUAL_DEPOSITS_QUERY = gql`
  query Payments_GetManualDeposits($employeeUUID: uuid!, $supplierUUID: uuid!) {
    getManualDeposits(employee_id: $employeeUUID, supplier_id: $supplierUUID) {
      alert_level
      alert_message
      deposits {
        ...ManualDepositSummaryFields
      }
    }
  }
  ${MANUAL_DEPOSIT_SUMMARY_FRAGMENT}
`;

export const useGetManualDeposits = ({
  employeeUUID,
  onError,
  skip,
  supplierUUID,
}: {
  employeeUUID: string;
  onError?: (error: ApolloError) => void;
  skip?: boolean;
  supplierUUID: string;
}) => {
  return useQuery<
    Payments_GetManualDepositsQuery,
    Payments_GetManualDepositsQueryVariables
  >(GET_MANUAL_DEPOSITS_QUERY, {
    fetchPolicy: 'cache-and-network',
    onError,
    skip,
    variables: { employeeUUID, supplierUUID },
  });
};
